export default "__VITE_ASSET__2bcc282e__"